import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  code: 200,
  data: {
    serviceExperience: {
      score: 95,
      connectSuccessRate: { status: "Warn", attempts: 10000, success: 6200, drop: 3800 },
      connectTime: { p95Seconds: 935, p50Seconds: 935, thresholdSeconds: 120, sessions: 10000 },
      guestAccessHappiness: { sessions: 10000, durationDistribution: { "0-60s": 42, "60-600s": 18, "600-3600s": 33, ">3600s": 7 } },
    },
    security: {
      score: 90,
      rogueApDetection: {
        rogueAp: 6,
        highRiskAp: 2,
        impactedSsid: 2,
        lastSeen: 1786557600,
      },
      abnormalLocation: { secured: 80, learning: 15, displaced: 5 },
    },
    roam: { score: 82, successRate: { status: "Good", totalEvents: 1801, successRate: 91, p95LatencyMs: 935 } },
    wirelessCoverage: { score: 86, signalQualification: { status: "Good", totalClients: 3, meanRssiDbm: -44.8, weakSignalRate: 33 } },
    linkIntegrity: {
      score: 72,
      wirelessCongestion: {
        totalAps: 80,
        status: "Warn",
        peakCongested: 5,
        avgCongested: 2,
        threshold: 30,
      },
      wiredCongestion: {
        status: "Moderate",
        peakCongested: 3,
        mostCongested: { device: { name: "SW-Core-01" } },
        threshold: 30,
      },
      wiredLinkDegration: { affectedSwitchCount: 5 },
      wiredCableQuality: {
        status: "Good",
        noisyPorts: 2,
        switchesWithErrorPorts: 23,
      },
      channelInterference: { status: "Good", noisySsids: 2, avgRssi: -92 },
    },
    operations: {
      score: 92,
      deviceReboot: { status: "Good", rebootCount: 18, peakRebootCount: 6 },
      poeError: {
        usedPower: 2850,
        totalPower: 4200,
        errorCounts: { pdShort: 17, overload: 8, powerDenied: 5, others: 3 },
      },
      uplinkInstability: {
        status: "Good",
        unlinkDevice: 0,
        eventCount: 0,
      },
      systemBottleneck: { status: "Good", avg: 22, threshold: 80 },
      firmwareStatus: {
        status: "Warn",
        distribution: { latest: 60, previous: 30, legacy: 10 },
      },
    },
  },
};

const summaryReportAInsightSlice = createSlice({ name: "summaryReportAInsight", initialState });

export default summaryReportAInsightSlice.reducer;
